












import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class<T extends { id: any }> extends Vue {
  @Prop(Array) items!: T[];
}
